import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Lock, DollarSign } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <AlertTriangle className="w-10 h-10 text-gold-accent mb-4" data-id="element-133" />,
    title: 'Miedo y Confusión',
    desc: 'Quieren que creas que llenar una forma 1040 es demasiado peligroso para hacerlo solo.'
  }, {
    icon: <Lock className="w-10 h-10 text-gold-accent mb-4" data-id="element-134" />,
    title: 'Muros de Pago Ocultos',
    desc: 'Usan palabras complicadas para quitarte entre $150 y $300 de tu reembolso antes de que llegue a tu cuenta.'
  }, {
    icon: <DollarSign className="w-10 h-10 text-gold-accent mb-4" data-id="element-135" />,
    title: "La Trampa 'Gratis'",
    desc: 'Esperan a que pases horas llenando datos para decirte que tu trabajo (Uber, construcción) requiere una actualización costosa.'
  }];
  return <section className="bg-navy-light py-20 md:py-28 text-white" data-id="element-136">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-138">
          <h2 className="text-4xl md:text-5xl font-bold uppercase mb-6" data-id="element-139">
            La industria prospera gracias a tu{' '}
            <span className="text-gold-accent" data-id="element-140">desinformación</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-141">
          {problems.map((prob, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-navy-dark p-8 rounded-xl border border-gray-700 hover:border-gold-accent transition-colors" data-id="element-142">
              {prob.icon}
              <h3 className="text-2xl font-bold font-heading mb-3" data-id="element-143">
                {prob.title}
              </h3>
              <p className="text-gray-300 font-body text-lg" data-id="element-144">{prob.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}